import React, { useState, useEffect } from 'react'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Modal } from 'react-bootstrap';
import JazzCashlogo from '../../Assetes/Images/jazzcash.png'
import Cashondelivery from '../../Assetes/Images/Cash-delivery-icon.jpg'
import CardPayment from '../../Assetes/Images/card-payment-icon.jpg'
import MachineAtDoorStep from '../../Assetes/Images/machine-at-doorstep.jpg'
import { Button } from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import { useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import { InputAdornment, MenuItem, Select } from '@mui/material';
import KFCJAZZCASHBLACK from '../../Assetes/Images/jazz_cash_animation_black.gif';
import KFCJAZZCASHWHITE from '../../Assetes/Images/jazz_cash_animation_white.gif';
import { toast } from 'react-toastify';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
let confirmationMessage = "";

export default function PaymentMode(props: any) {
    const [confirm, setConfirmation] = useState(false)
    const [paymentObj, setPaymentObj]: any = useState(null)
    const { t } = useTranslation();

    const cashCddConfirmation = (paymentMode: any) => {
        confirmationMessage = `${t("ARE_YOU_SURE_YOU_WANT_TO_PROCEED_WITH")}`;
        setConfirmation(true);
        setPaymentObj(paymentMode);
    }
    const finalConfirmation = () => {
        props.emptyPaymentMethod();
        props.calculationAfterPaymentMethodSelection(paymentObj.payment_method)
        setTimeout(() => {
            props.savePaymentMethod(paymentObj.payment_method);
        }, 500)
        setConfirmation(false)
        saveTrackig(`Select ${paymentObj.payment_method}`)
    }
    const saveTrackig = (activity: any) => {
        props.paymentTracking(activity)
    }
    return (
        <div>
            <FormControl className='w-100'>
                {!props.payment_modes || props.payment_modes.length == 0 ? <div className='text-center p-4'><CircularProgress size={25} color={"inherit"} /></div> :
                    <RadioGroup aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group" className='w-100'>
                        {
                            props.payment_modes && props.payment_modes
                                .filter((obj: any, index: any) => {
                                    if (props.jazzcash == true) {
                                        return obj.payment_method_id === 4
                                    }
                                    else {
                                        return obj
                                    }
                                })
                                .map((obj: any, index: any) => {
                                    return (
                                        <>
                                            <div className='payment-mod-check' key={index}>
                                                <FormControlLabel value={obj.payment_method} label={
                                                <div className='d-flex align-items-center gap-10'>
                                                    <img src={obj.payment_method_id == 1 ? Cashondelivery : obj.payment_method_id == 2 ? CardPayment : obj.payment_method_id == 3 ? JazzCashlogo : obj.payment_method_id == 4 ? JazzCashlogo : obj.payment_method_id == 5 ? MachineAtDoorStep : ""} alt={obj.payment_method_description} />
                                                    <span>{obj.payment_method_description}</span>
                                                </div>
                                            } control={<Radio color='error' {...((props.radioButton || (props.paymentMethod == obj.payment_method)) ? null : {
                                                onClick: () => {
                                                    if (obj.payment_method == "Cash" || obj.payment_method == "CDD") {
                                                        cashCddConfirmation(obj)
                                                    } else {
                                                        props.calculationAfterPaymentMethodSelection(obj.payment_method)
                                                        props.emptyPaymentMethod();
                                                        setTimeout(() => {
                                                            props.savePaymentMethod(obj.payment_method);
                                                        }, 500)
                                                        saveTrackig(`Select ${obj.payment_method}`)
                                                    }
                                                }
                                            })}
                                                {...((props.paymentMethod == (obj.payment_method)) ? {
                                                    checked: true
                                                } : { checked: false })} />} />
                                            </div>
                                        </>
                                    )
                                })
                        }
                    </RadioGroup>
                }
            </FormControl>
            
            {/* Popup Confirmation for Cash and Card */}
            <Modal className='track-modal' show={confirm} backdrop={"static"} centered>
                <div className='modal-design'>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <Modal.Header className='justify-content-center'>
                </Modal.Header>
                <Modal.Body className='w-100 delivery-order text-center py-4'>
                    {confirmationMessage}
                    <div className='d-flex justify-content-between gap-10'>
                        <Button onClick={() => { setConfirmation(false) }} className='w-50 m-auto d-flex mt-4 color-white' variant="outlined" color="error">{t("CANCEL")}</Button>
                        <Button onClick={() => {
                            finalConfirmation()
                        }} className={`w-50 m-auto d-flex mt-4 bg-theme`} variant="contained" color="error">{t("YES")}</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}
